module.exports = __webpack_public_path__ + "img/energyImg6.3dfbd901.png";